import React from 'react';
import { DatePicker, Typography } from 'antd';
import dayjs from 'dayjs';
import { primaryShades } from '../../../theme/theme';

const { Text } = Typography;
const { RangePicker } = DatePicker;

// Costanti dei colori
const PRIMARY_700 = primaryShades.primary700;

// Presets predefiniti per il date range picker
const rangePresets = [
    {
        label: 'Today',
        value: [dayjs().startOf('day'), dayjs().endOf('day')],
    },
    {
        label: 'Yesterday',
        value: [
            dayjs().subtract(1, 'day').startOf('day'),
            dayjs().subtract(1, 'day').endOf('day'),
        ],
    },
    {
        label: 'This Week',
        value: [dayjs().startOf('week'), dayjs().endOf('day')],
    },
    {
        label: 'Last Week',
        value: [
            dayjs().subtract(1, 'week').startOf('week'),
            dayjs().subtract(1, 'week').endOf('week'),
        ],
    },
    {
        label: 'This Month',
        value: [dayjs().startOf('month'), dayjs().endOf('day')],
    },
    {
        label: 'Last Month',
        value: [
            dayjs().subtract(1, 'month').startOf('month'),
            dayjs().subtract(1, 'month').endOf('month'),
        ],
    },
    {
        label: 'Last 3 Months',
        value: [dayjs().subtract(3, 'month').startOf('day'), dayjs().endOf('day')],
    },
    {
        label: 'Last 6 Months',
        value: [dayjs().subtract(6, 'month').startOf('day'), dayjs().endOf('day')],
    },
    {
        label: 'This Year',
        value: [dayjs().startOf('year'), dayjs().endOf('day')],
    },
];

const RangePickerComponent = ({
    label,
    value,
    onChange,
    format = "DD/MM/YYYY",
    placement = "bottomLeft",
    style = {}
}) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            ...style
        }}>
            {label && (
                <Text style={{
                    marginBottom: 'clamp(0.25rem, 1vw, 0.5rem)',
                    color: PRIMARY_700,
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)'
                }}>
                    {label}
                </Text>
            )}
            <RangePicker
                value={value}
                onChange={onChange}
                format={format}
                presets={rangePresets}
                placement={placement}
                style={{
                    width: '100%',
                    height: 'clamp(2rem, 5vw, 2.25rem)',
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                    padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 0.75rem)'
                }}
                popupStyle={{
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)'
                }}
                popupClassName="responsive-date-dropdown"
            />
        </div>
    );
};

export default RangePickerComponent; 